export default __webpack_public_path__ + "static/media/background.45b1381e.png";